import request from '@/utils/request'
import airDropRequest from '@/utils/airDropRequest'


export const getMeasurementPoint = () => {
  return request({
    url: '/producer/getMeasurementPoint',
    method: 'get',
    vconfig:{
      ContentType:"application/json"
    }
  })
}

// businessKYCEntrance
export const businessKYCEntrance = (data) => {
  return request({
    url: '/api/producer/kyb',
    method: 'post',
    data:data,
    vconfig:{
      ContentType:"application/json"
    }
  })
}
// personalKYCEntrance
export const personalKYCEntrance = (data) => {
  return request({
    url: '/api/producer/kyc',
    method: 'post',
    data:data,
    vconfig:{
      ContentType:"application/json"
    }
  })
}

// producer set basic info
export const producerSetInfo = (data) => {
  return request({
    url: '/producer/setInfo',
    method: 'post',
    data:data
  })
}
// producer set measurementPoint info
export const addMeasurementPoint = (data) => {
  return request({
    url: '/producer/addMeasurementPoint',
    method: 'post',
    data:data,
    vconfig:{
      ContentType:"application/json"
    }
  })
}
// producer set well info
export const addWell = (data) => {
  return request({
    url: '/producer/addWell',
    method: 'post',
    data:data,
    vconfig:{
      ContentType:"application/json"
    }
  })
}
// producer get my info
export const producerMyInfo = (param) => {
  return request({
    url: '/producer/myInfo',
    method: 'get',
    param:param
  })
}
// producer update my well info
export const updateWell = (data) => {
  return request({
    url: '/producer/updateWell',
    method: 'post',
    data:data,
    vconfig:{
      ContentType:"application/json"
    }
  })
}
export const updateMeasurementPoint = (data) => {
  return request({
    url: '/producer/updateMeasurementPoint',
    method: 'post',
    data:data,
    vconfig:{
      ContentType:"application/json"
    }
  })
}
export const delMPandWell = (data) => {
  return request({
    url: '/producer/delMPandWell',
    method: 'post',
    data:data,
    vconfig:{
      ContentType:"application/json"
    }
  })
}
export const updateWellParams = (data) => {
  return request({
    url: '/producer/updateWellParams',
    method: 'post',
    data:data,
    vconfig:{
      ContentType:"application/json"
    }
  })
}
export const checkWell = (data) => {
  return request({
    url: '/api/producer/checkWell',
    method: 'post',
    data:data
  })
}
export function expiredWell(data) {
  return request({
    url: '/producer/expiredWell',
    method: 'get',
    params:data,
    // vconfig:{
    //   baseApi:process.env.VUE_APP_MPLATFORM_API,
    // }
  })
}


///api/v1.0/tokenlocker/lockedRecords
export const lockedRecords = (data) => {
  let param = {}
  if(data.account){
    param.account = data.account
  }
  if(data.page){
    param.page = data.page
  }
  if(data.pageSize){
    param.pageSize = data.pageSize
  }
  return airDropRequest({
    url: '/api/v1.0/tokenlocker/lockedRecords',
    method: 'get',
    params:param
  })
}



